import { Component } from '@angular/core';

@Component({
  selector: 'icon-cross',
  templateUrl: './icon-cross.component.html',
  styleUrls: ['./icon-cross.component.scss']
})
export class IconCrossComponent {
}
